module.exports = __webpack_public_path__ + "static/media/item_6_34_comp.98758019.png";